import * as helper from './helper';

// 当前页面Name
const menuHref = window.location.href;
const menuPath = menuHref.split('/').pop();
const nowPathName = menuPath.split('.').shift() || 'index';

// 初始化头部
function initHeader () {
  const headerSimple = document.querySelector('.page-header-simple');
  const computedStyle = window.getComputedStyle(headerSimple);
  // 看当前展示的是 小屏版还是pc版，给对应的添加样式
  const displayStatus = computedStyle.getPropertyValue('display');
  if (displayStatus === 'none') {
    // 给当前url的title添加选中样式
    const links = document.querySelectorAll('.pull-right.page-menu li');
    links.forEach(function (li) {
      const linkUrl = li.id;
      if (nowPathName === linkUrl) {
        li.classList.add('active');
      }
    });
  } else {
    const links = document.querySelectorAll('.page-drawer li');
    links.forEach(function (li) {
      const linkUrl = li.id;
      if (nowPathName === linkUrl) {
        const span = li.querySelector('span.text');
        span.classList.add('activeTest');
      }
    });
  }
}


// 如果浏览器是ie11 并且当前页面是关于我们就重新设置偏移量
const skewing = (nowPathName === 'aboutUs' && helper.IEVersion() === 11) ? 2850 : 850;
const bottomSite = document.body.clientHeight - document.getElementById('contact').clientHeight;
const header = document.getElementById('header');
document.addEventListener('scroll', () => {
  // 滚动到联系我们时 给联系我们菜单添加样式
  const rollHight = document.body.scrollTop || document.documentElement.scrollTop;
  if (rollHight > (bottomSite - skewing)) {
    isClass('menuCon', true);
    isClass(nowPathName, false);
  } else {
    isClass('menuCon', false);
    isClass(nowPathName, true);
  }
  handleScroll(header);
});
// 是否给菜单添加class, type:true(添加)|false(删除)
function isClass (domId, type) {
  const getDom = document.getElementById(domId);
  type ? helper.addClass(getDom, 'active')
    : helper.removeClass(getDom, 'active');
}

/**
 * 处理头部浮动
 * @param target
 */
function handleScroll (target) {
  const containsFixedClass = target.classList.contains('fixed'); // 是否存在 fixed 类
  if ((document.documentElement.scrollTop || document.body.scrollTop) > 80) {
    if (containsFixedClass) return;
    helper.addClass(target, 'fixed');
  } else {
    if (!containsFixedClass) return;
    helper.removeClass(target, 'fixed');
  }
}

initHeader();
